import { Box, Text, Grid, Flex } from '@sparrowengg/twigs-react'
import React from 'react'
import { v4 as uuidv4 } from 'uuid';

function SmsListView({ data, activePage }) {
  // Function to calculate the time difference
  const calculateTimeDifference = (timestamp) => {
    let isoTimestamp = timestamp.replace(' ', 'T') + 'Z'; // Convert to ISO format
    const messageTimeUTC = new Date(isoTimestamp);

    if (isNaN(messageTimeUTC.getTime())) {
      throw new RangeError("Invalid time value");
    }

    const nowUTC = new Date();
    const difference = nowUTC.getTime() - messageTimeUTC.getTime();

    const years = Math.floor(difference / (1000 * 60 * 60 * 24 * 365));
    const days = Math.floor((difference / (1000 * 60 * 60 * 24)) % 365);
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((difference / (1000 * 60)) % 60);
    const seconds = Math.floor((difference / 1000) % 60);

    if (years > 0) {
      return `${years} year${years > 1 ? 's' : ''} ago`;
    } else if (days > 0) {
      return `${days} day${days > 1 ? 's' : ''} ago`;
    } else if (hours > 0) {
      return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    } else if (minutes > 0) {
      return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    } else {
      return `${seconds} second${seconds > 1 ? 's' : ''} ago`;
    }
  };

  // Function to render message with clickable links
  const renderMessageWithLinks = (message) => {
    // Regular expression to match URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = message.split(urlRegex);
    
    return parts.map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#007bff',
              textDecoration: 'underline',
              cursor: 'pointer',
              fontFamily: 'DM Sans',
              fontSize: '$3',
              fontWeight: '400',
              lineHeight: '1.5'
            }}
          >
            {part}
          </a>
        );
      }
      return part;
    });
  };

  return (
    <Box css={{
      width: '100%',
      padding: '$6 $4',
      overflow: 'scroll',
      height: 'calc(100vh - 60px)',
      '& > div': {
        borderBottom: '1px solid #EAEFF4 !important',
        padding: '$4 0',
        '&:last-child': {
          borderBottom: 'none',
        },
      },
    }}>
      {data.length > 0 && data.map(sms => (
        <Grid
          key={uuidv4()}
          templateColumns='176px 1fr 54px 108px'
          css={{ alignItems: 'center' }}
        >
          <Box>
            <Flex gap="$2" css={{ paddingBottom: '$2' }}>
              <Text size="sm" css={{ fontWeight: 'bold' }}>From :</Text>
              <Text size="sm">{sms.sender}</Text>
            </Flex>

            <Flex gap="$2" css={{ marginTop: '$2' }}>
              <Text size="sm" css={{ fontWeight: 'bold' }}>To :</Text>
              <Text size="sm">{sms.receiver}</Text>
            </Flex>
          </Box>
          <Box css={{ 
            fontFamily: 'DM Sans', 
            textAlign: 'left', 
            padding: '0 $6', 
            fontWeight: '400',
            fontSize: '$3',
            lineHeight: '1.5'
          }}>
            {renderMessageWithLinks(sms.message)}
          </Box>
          <Flex css={{ justifyContent: 'center', alignItems: 'center' }}>
            <Text>{sms.segments_used}</Text>
          </Flex>
          <Flex css={{ justifyContent: 'center', alignItems: 'center' }}>
            <Text>{calculateTimeDifference(sms.timestamp)}</Text>
          </Flex>
        </Grid>
      ))}
      {data.length === 0 && (
        <Text size="md" css={{ textAlign: 'center' }}>No messages to display</Text>
      )}
    </Box>
  );
}

export default SmsListView;